
define('text!modules/strategy/templates/itemAdditionalLayout.html',[],function () { return '<div class="health-checklist">\n\t//The Health Checklist Dialog is rendered in here\n</div>\n';});

